import { useMemo } from "react";

import { useMediaQuery } from "@/hooks";
import { conflitoLabel } from "@/modules/carga-trabalho";
import { marcaSaidaKey, SEM_MARCAS } from "@/modules/recursos/simulacao";

import { ganttScaleOf, monthMinWidth } from "@/shared/components/gantt-carga/gantt-scale";
import { CARGA_TRABALHO_MOBILE_QUERY } from "@/shared/components/gantt-carga/mobile";
import {
  LAYOUT_PRESET,
  MOBILE_ROW_MIN_HEIGHT_REM,
  ROW_MIN_HEIGHT_REM,
} from "./gantt-local.constants";
import type { GanttLocalProps, GanttLocalViewModel } from "./types-gantt-local";

export function useGanttLocal({
  rows,
  onResolver,
  timeline,
  today,
  marcas = SEM_MARCAS,
}: GanttLocalProps): GanttLocalViewModel {
  const isMobile = useMediaQuery(CARGA_TRABALHO_MOBILE_QUERY);
  const scale = useMemo(() => ganttScaleOf(timeline), [timeline]);

  return {
    rows,
    onResolver,
    today,
    marcas,
    marcaDaLinha: (row) =>
      row.items.map((item) => marcas.get(item.key)).find(Boolean) ??
      marcas.get(marcaSaidaKey(row.key)),
    rotuloConflito: conflitoLabel,
    scale,
    rowMinHeightRem: isMobile ? MOBILE_ROW_MIN_HEIGHT_REM : ROW_MIN_HEIGHT_REM,
    unitMinWidth: monthMinWidth(LAYOUT_PRESET, isMobile),
  };
}
